import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=22fb7b3a&scoped=true&"
import script from "./ContactForm.vue?vue&type=script&lang=js&"
export * from "./ContactForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactForm.vue?vue&type=style&index=0&id=22fb7b3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fb7b3a",
  null
  
)

export default component.exports